import { render, staticRenderFns } from "./ImportEvent.vue?vue&type=template&id=5a16892e&"
import script from "./ImportEvent.vue?vue&type=script&lang=js&"
export * from "./ImportEvent.vue?vue&type=script&lang=js&"
import style0 from "./ImportEvent.vue?vue&type=style&index=0&id=5a16892e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports